import type { RecentlyVisitedItem } from "@/hooks/useRecentlyVisited";

type ActivityRecentlyVisitedSource = {
  id?: string | null;
  title?: string | null;
  createdAt?: string | null;
  activityType?: { title?: string | null } | null;
  managingSection?: { name?: string | null } | null;
  event?: unknown;
};

export function toActivityRecentlyVisitedItem({
  activityTypeId,
  activityId,
  activity
}: {
  activityTypeId: string;
  activityId: string;
  activity: ActivityRecentlyVisitedSource | null | undefined;
}): Omit<RecentlyVisitedItem, "dateTime"> | null {
  if (!activityTypeId || !activityId || !activity?.createdAt || !activity.title) {
    return null;
  }
  if (activity.id !== activityId) {
    return null;
  }

  const typeTitle = typeof activity.activityType?.title === "string" ? activity.activityType.title.trim() : "";
  const sectionName = typeof activity.managingSection?.name === "string" ? activity.managingSection.name.trim() : "";

  return {
    url: `/activities/activity-types/${activityTypeId}/activity/${activityId}`,
    text: activity.title,
    subtext: [typeTitle, sectionName].filter(Boolean).join(" · "),
    image: activity.event ? "today" : "assignment",
    type: "activities"
  };
}
